import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserSnifferService } from '../../services/browser-sniffer.service';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from '../../services/language.service';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PermalinkService } from '../../services/permalink.service';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tt-language-chooser',
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './language-chooser.component.html',
  styleUrl: './language-chooser.component.scss',
  animations: [
    trigger('openClose', [
      state('open', style({
        height: '{{panelHeight}}px',
        //  minHeight: '100%',
      }), { params: { panelHeight: '124' } }),
      state('closed', style({
        height: '48px',
      })),
      transition('* => closed', [
        animate('0.15s cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
      transition('* => open', [
        animate('0.25s cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
      transition('closed => void', [
        animate('0.25s cubic-bezier(0.4, 0.0, 0.2, 1)'),
        style({
          height: '56px',
        })
      ]),
    ]),
  ]
})
export class LanguageChooserComponent implements OnInit, OnDestroy {
  //trigger button is not included in the template anymore, the reference is now passed via the menuOpened method
  //@ViewChild(MatMenuTrigger) languageChooserTriggerBtn!: MatMenuTrigger;
  private languageChooserTriggerBtn?: MatMenuTrigger
  @ViewChild('menu', { static: true }) public menu: MatMenu;
  @Input() showAsIcon!: boolean;
  isOpen!: boolean;
  isAnimating!: boolean;
  panelHeight!: number;
  private backEventSubscription: Subscription = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public browserSniffer: BrowserSnifferService,
    public languageService: LanguageService,
    private permalinkService: PermalinkService,
    private toggleEventService: ToggleEventService,
    private backEventService: BackEventService
  ) {

  }

  ngOnInit() {
    if (!this.languageService.selectedLang()) {
      this.languageService.init();
    }

    /*
    this causes the current path to be replaced with the default startup path /objects?l=xx

    this.activatedRoute.queryParams
      .subscribe(params => {
        if (!params["l"]) {
          this.setLanguageQueryParams(this.languageService.selectedLang);
        }
      })
   */

    this.panelHeight = 56 * this.languageService.availableLanguages.length;
  }

  ngOnDestroy(): void {
    this.backEventSubscription?.unsubscribe();
  }

  menuOpened(triggerReference: MatMenuTrigger) {
    if (triggerReference) {
      if (!this.backEventSubscription) {
        this.backEventSubscription = this.toggleEventService.emitter$.subscribe(
          (toggleEvent: ToggleEventType) => {
            if (toggleEvent.forwardedFor === 'language-chooser' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
              //language in header component doesn't really need to close, header closes anyway
              //this.isOpen = false;
              this.languageChooserTriggerBtn?.closeMenu();
            }
          }
        );
      }

      this.languageChooserTriggerBtn = triggerReference;

      this.backEventService.registerOpenedWindow({ windowName: 'language-chooser', isAutoCloseableWindow: false });
    }
  }

  onSwitchLanguage(lang: string) {
    if (lang !== this.languageService.selectedLang()) {
      this.languageService.setLanguage(lang);
      this.permalinkService.updateLanguage(lang);
      // this.setLanguageQueryParams(lang);
    }
  }

  selectedIndex!: number;

  setSelectElement(lang: string) {
    this.togglePane();
    if (lang === this.languageService.availableLanguages[0]) {
      return;
    } else {
      this.languageService.setLanguage(lang);
      this.permalinkService.updateLanguage(lang);
      // this.setLanguageQueryParams(lang);

      //wait till pane has closed
      // setTimeout(() => {
      // this.sortArray(this.selectedIndex);
      // this.availableLanguages = this.sortLanguages(this.availableLanguages, lang);
      // }, 150);
    }
  }

  setLanguageQueryParams(language: string) {
    // console.log('disabled set query params');

    // //this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { "l": language }, queryParamsHandling: "merge"});
    // this.router.navigate([], {
    //   relativeTo: this.activatedRoute,
    //   preserveFragment: true,
    //   queryParams:
    //     { l: language }
    //   ,
    //   queryParamsHandling: "merge"
    // });
  }

  togglePane() {
    this.isOpen = !this.isOpen;
  }

  onAnimationEventStart(event: any) {
    this.isAnimating = true;
  }

  onAnimationEventEnd(event: any) {
    this.isAnimating = false;
    if (event.fromState === 'open' && event.phaseName === 'done') {
      //  this.isOpen=true;
    }
    else {
      //  this.isOpen=false;
    }
  }
}
